
































import { Component, Vue } from 'vue-property-decorator'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import { DataTableHeader } from 'vuetify'
import { DefaultServerResponse } from '@/components/ui/TechTaskCard.vue'
import request from '@/helpers/requests'
import { Ripple } from 'vuetify/lib/directives'

// Data Objects
interface Campaign {
    pulsemAccountId: number;
    username: string;
    email: string;
    employeeID: string;
    password: string;
}

// Action-specific request payloads
interface LoadRequestPayload {
    pulsemAccountId: number;
}

// Action-specific response payloads
interface LoadResponsePayload extends DefaultServerResponse {
    data: Array<Campaign>;
}

@Component({
    components: {
        AccountIdInput
    },
    directives: {
        Ripple
    }
})

export default class CampaignCredentials extends Vue {
    locationValid = false
    pulsemAccountId: number|null = null
    campaigns: Array<Campaign> = [];


    // Table handling properties
    isLoading = true; // This one is for AccountIdInput & full table loading
    headers: Array<DataTableHeader> = [
        { text: 'Name', value: 'name' },
        { text: 'Username', value: 'fieldopsUsername' },
        { text: 'Password', value: 'fieldopsPassword' },
        { text: 'Email', value: 'email' },
        { text: 'Employee ID', value: 'id' }
    ];

    search = '';

    // AccountIdInput support
    async onLocationChange(locationValid: boolean) {
        this.locationValid = locationValid
        if (this.locationValid) {
            this.isLoading = true
            const response = await this.loadCampaigns()
            this.campaigns = response.data
        } else {
            this.campaigns = []
        }
        this.isLoading = false
    }

    async loadCampaigns(): Promise<LoadResponsePayload> {
        return await request.post('/support/campaign-credentials-load', {
            pulsemAccountId: this.pulsemAccountId
        } as LoadRequestPayload) as LoadResponsePayload
    }
}
